/**
 * SokoTree Theme JavaScript
 * Pure vanilla JavaScript for SokoTree Shopify OS 2.0 Theme
 */

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initSmoothScroll();
  initAccordions();
  initEscapeKeyClose();
});

/**
 * Mobile Navigation Drawer Toggle & Scroll Lock
 */
function initMobileMenu() {
  const toggleButtons = document.querySelectorAll('.js-mobile-toggle');
  const drawer = document.getElementById('SokoTreeMobileNav');
  const drawerLinks = document.querySelectorAll('.mobile-nav-link, .js-mobile-link');

  if (!drawer || toggleButtons.length === 0) return;

  function openMenu() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-nav-active');
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-nav-active');
  }

  function toggleMenu() {
    if (drawer.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  toggleButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMenu();
    });
  });

  drawerLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });
  });
}

/**
 * Smooth Scroll for Anchors
 */
function initSmoothScroll() {
  const scrollLinks = document.querySelectorAll('.js-scroll-to');

  scrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      if (targetId && targetId.startsWith('#')) {
        const targetEl = document.querySelector(targetId);
        if (targetEl) {
          e.preventDefault();
          targetEl.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
}

/**
 * Collapsible Accordions (FAQ & Product Details)
 */
function initAccordions() {
  const accordionButtons = document.querySelectorAll('.js-accordion-header');

  accordionButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const content = document.getElementById(btn.getAttribute('aria-controls'));

      btn.setAttribute('aria-expanded', !expanded);
      if (content) {
        if (!expanded) {
          content.removeAttribute('hidden');
          content.classList.add('is-active');
        } else {
          content.setAttribute('hidden', '');
          content.classList.remove('is-active');
        }
      }
    });
  });
}

/**
 * Escape Key Global Listener to Close Overlays
 */
function initEscapeKeyClose() {
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (window.SokoTreeCart?.closeDrawer) window.SokoTreeCart.closeDrawer();
      if (window.SokoTreeSearch?.closeModal) window.SokoTreeSearch.closeModal();
      
      const mobileDrawer = document.getElementById('SokoTreeMobileNav');
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        mobileDrawer.classList.remove('is-open');
        mobileDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('mobile-nav-active');
      }
    }
  });
}

/**
 * Global Toast Notification Helper
 */
window.SokoTree = window.SokoTree || {};
window.SokoTree.showNotification = function(message, type = 'info') {
  let toastContainer = document.querySelector('.sokotree-toast-container');
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'sokotree-toast-container';
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement('div');
  toast.className = `sokotree-toast toast--${type}`;
  toast.innerHTML = `<span>${message}</span>`;
  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.classList.add('is-visible');
  }, 10);

  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 300);
  }, 3500);
};
